export default __webpack_public_path__ + "static/media/logo-bayadFA-white.2f1b3d50.svg";